<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useDashboardAppStore } from "@/stores/dashboardApp";
import constants from "@/constant";

const router = useRouter();
const dashboardApp = useDashboardAppStore();
const { selectedApp } = storeToRefs(dashboardApp);

const selectRiktigaVykort = () => {
  dashboardApp.setSelectedApp(constants.DASHBOARD_APPS.RIKTIGA_VYKORT);
  router.push({ name: "search" });
};
const selectCreateMailOut = () => {
  dashboardApp.setSelectedApp(constants.DASHBOARD_APPS.CREATE_MAIL_OUT);
  router.push({ name: "mailout" });
};
</script>

<template>
  <div class="app-switcher flex align-center gap-16">
    <label :for="constants.DASHBOARD_APPS.RIKTIGA_VYKORT">
      <pn-radio-button
        :radioid="constants.DASHBOARD_APPS.RIKTIGA_VYKORT"
        name="dashboardApp"
        :value="constants.DASHBOARD_APPS.RIKTIGA_VYKORT"
        :checked="selectedApp === constants.DASHBOARD_APPS.RIKTIGA_VYKORT"
        @change="selectRiktigaVykort"
      />
      Riktiga Vykort
    </label>
    <label :for="constants.DASHBOARD_APPS.CREATE_MAIL_OUT">
      <pn-radio-button
        :radioid="constants.DASHBOARD_APPS.CREATE_MAIL_OUT"
        name="dashboardApp"
        :value="constants.DASHBOARD_APPS.CREATE_MAIL_OUT"
        :checked="selectedApp === constants.DASHBOARD_APPS.CREATE_MAIL_OUT"
        @change="selectCreateMailOut"
      />
      Create Mail Out
    </label>
  </div>
</template>

<style lang="scss" scoped>
.app-switcher {
  margin-bottom: 1em;
  label {
    cursor: pointer;
    color: #5e554a;
    display: flex;
    align-items: center;
  }
}
</style>
